import { isValidTelUrl } from "./is-valid-te-url.js";
import { linkify } from "./linkify/linkify.js";
const normalizeHref = (value) => {
  if (isValidTelUrl(value)) {
    return value;
  }
  const [urlValue, anchor] = value.split("#");
  const normalizedUrl = urlValue && linkify.match(urlValue) && linkify.match(urlValue)?.[0]?.url;
  if (normalizedUrl === null) {
    return void 0;
  }
  return anchor ? `${normalizedUrl}#${anchor}` : normalizedUrl;
};
export {
  normalizeHref
};
//# sourceMappingURL=normalize-href.js.map
